import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerService } from '../index';
import { Router } from '@angular/router';
import { Customer } from '../../models/customer';
import {
  MatRadioChange,
  MatRadioGroup,
  MatRadioButton
} from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { AddressSelectorComponent } from './address-selector/address-selector.component';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { NgIf } from '@angular/common';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
  selector: 'add-customer',
  templateUrl: './add.customer.component.html',
  providers: [CustomerService],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatDialogTitle,
    MatSlideToggle,
    MatDialogContent,
    MatRadioGroup,
    MatRadioButton,
    NgIf,
    MatFormField,
    MatLabel,
    MatInput,
    AddressSelectorComponent,
    MatButton,
    MatDialogActions
  ]
})
export class AddCustomerComponent {
  model: Partial<Customer> = {
    business: 0,
    hires_disabled: 0
  };

  @Input() embeddedView = false;
  @Output() customerCreated = new EventEmitter<Customer>();
  @Output() canceled = new EventEmitter();
  selectAddress = true;

  constructor(
    private customerService: CustomerService,
    private router: Router
  ) {}

  public submit() {
    this.customerService.addCustomer(this.model).subscribe(
      (response) => {
        if (!this.embeddedView) {
          this.router.navigate(['/customer/' + response.id]);
          return;
        }
        this.customerCreated.emit(response);
      },
      (error) => {}
    );
  }

  typeChanged(event: MatRadioChange) {
    if (event.value === 1) {
      this.customerService.changedToBusiness(this.model);
      return;
    }
    if (event.value === 1) {
      this.customerService.changeToIndividual(this.model);
      return;
    }
  }

  cancel() {
    if (!this.embeddedView) {
      this.router.navigate(['customers']);
      return;
    }
    this.canceled.emit();
  }

  loadAddress(address: any) {
    if (address) {
      this.model = { ...this.model, ...address };
      this.selectAddress = false;
    }
  }
}
